export const HAS_UPPER_AND_LOWER_LETTER = /(?=.*[a-z])(?=.*[A-Z])/;

export const HAS_NUMBER = /\d/;

export const HAS_SPECIAL_CHAR = /[!@#$%^&*()_+{}[\]:;<>,.?~\\-]/;

export const STATUS_SPACE_TO_UNDERSCORE = /\s+/g;
export const UNDERSCORE_GLOBAL = /_/g; // Matches all underscores to replace them with hyphens (e.g., "notice_period" → "notice-period")
export const CURRENCY_PREFIX_SPACE_REGEX = /(S\/)[\s\u00A0]+/;
export const SPACE_OR_UNDERSCORE_REGEX = /[\s_]+/g; // checks for spaces and under score
